import { Users } from 'lucide-react'
import { cn } from '../../lib/utils'
import { Skeleton } from '../ui/skeleton'

/** A group's photo as a square tile (its cover, cropped), or a muted tile with the Users icon. */
export function GroupPhoto({
  imageUrl,
  loading,
  className = 'size-24',
}: {
  imageUrl?: string
  loading?: boolean
  className?: string
}) {
  if (loading) return <Skeleton className={cn('shrink-0 rounded-xl', className)} />
  if (imageUrl) {
    return <img src={imageUrl} alt="" className={cn('shrink-0 rounded-xl object-cover', className)} />
  }
  return (
    <div className={cn('flex shrink-0 items-center justify-center rounded-xl bg-muted text-muted-foreground', className)}>
      <Users className="size-1/3" />
    </div>
  )
}
